import { Component, OnInit, Input, TemplateRef, ViewChild } from '@angular/core';
import { JobService } from '../../../../services/job/job.service';
import { environment } from '../../../../../../../environments/environment'
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
@Component({
    selector: 'app-overview-notes',
    templateUrl: './overview-notes.component.html',
    styleUrls: ['./overview-notes.component.scss']
})
export class OverviewNotesComponent implements OnInit {
    @Input() job;
    // Order logs link in the footer (see OverviewComponent.loadAccess).
    @Input() canViewLogs = false;
    // Flagging notes as alerts and deleting notes; not for inspectors (twin-ci has neither).
    @Input() canManageNotes = true;
    // 'home': Home Inspection Notes (home_manager_note, job_home_note); 'termite': the job's notes.
    @Input() service: 'termite' | 'home' = 'termite';
    get isHome(): boolean { return this.service === 'home'; }
    // Both panels can be on the page at once, so the home one's element ids are prefixed.
    get idPrefix(): string { return this.isHome ? 'home_' : ''; }
    @ViewChild('alertNotesModal') templateRef: TemplateRef<any>;
    private doSpace = environment.doSpace;
    private _modalRef: NgbModalRef;
    notes = {
        manager_note: '',
        is_manager_note_alert: 0
    };

    is_parent_notes = 0;
    parent_notes = [];

    addnotes = {
        add_notes: '',
        is_note_alert: 0
    }
    additional_notes = [];
    parent_additional_notes = [];
    alert_manager_notes = [];
    alert_additional_notes = [];
    is_loading: boolean;
    userData;
    permission: boolean;
    // front_office:boolean;

    constructor(public jobService: JobService, private modalService: NgbModal) { }

    ngOnInit() {
        this.userData = JSON.parse(localStorage.getItem('user'));
        if (this.isHome) {
            // The alert pop-up stays with the termite notes (one pop-up per page).
            this.notes.manager_note = this.job.home_manager_note || '';
            this.notes.is_manager_note_alert = this.job.is_home_manager_note_alert;
            this.additional_notes = this.job.home_notes || [];
            return;
        }
        this.notes.manager_note = this.job.manager_note
        this.notes.is_manager_note_alert = this.job.is_manager_note_alert
        this.additional_notes = this.job.parent_additional_notes

        // check if there are alert notes
        this.checkForAlertNotes();
    }

    noteId(item): number {
        return this.isHome ? item.job_home_note_id : item.job_note_id;
    }

    noteText(item): string {
        return this.isHome ? item.job_home_note_note : item.job_note_note;
    }

    managerNote() {
        const note = this.isHome
            ? { home_manager_note: this.notes.manager_note, is_home_manager_note_alert: this.notes.is_manager_note_alert ? 1 : 0 }
            : this.notes;
        this.jobService.managerNote(note, this.job.job_id).subscribe(
            data => {
                Swal({
                    title: 'Success',
                    text: 'Note updated successfully'
                })
                this.notes.manager_note = this.isHome ? data.data.home_manager_note : data.data.manager_note
            }
        );
    }
    addNote() {
        this.is_loading = true;
        const request = this.isHome
            ? this.jobService.homeNote(this.addnotes, this.job.job_id)
            : this.jobService.additionalNote(this.addnotes, this.job.job_id);
        request.subscribe(
            data => {
                Swal({
                    title: 'Success',
                    text: 'Added successfully'
                })
                this.is_loading = false;
                this.addnotes.add_notes = ''
                this.addnotes.is_note_alert = 0
                this.additional_notes = data.data
            },
            () => this.is_loading = false
        );
    }

    checkForAlertNotes() {
        if (this.notes.is_manager_note_alert) {
            this.alert_manager_notes[this.alert_manager_notes.length] = { 'notes': this.notes.manager_note };
        }
        // check for parent manager note
        // if (this.job.parent_manager_notes.length > 0) {
        //     for (let i = 0; i < this.job.parent_manager_notes.length; i++) {
        //         let parent_manage_note = this.job.parent_manager_notes[i];
        //         if (parent_manage_note == "") {
        //             continue;
        //         }
        //         this.alert_manager_notes[this.alert_manager_notes.length] = { 'notes': parent_manage_note };
        //         this.parent_notes[this.parent_notes.length] = {
        //             manager_note: parent_manage_note,
        //             is_manager_note_alert: 0
        //         };
        //     }

        //     this.is_parent_notes = 1;
        // }

        // check for additional notes
        if (this.additional_notes.length > 0) {
            for (let i = 0; i < this.additional_notes.length; i++) {
                if (this.additional_notes[i].is_note_alert) {
                    this.alert_additional_notes[this.alert_additional_notes.length] = this.additional_notes[i];
                }
            }
        }
        // check for parent additional notes
        // if (this.job.parent_additional_notes.length > 0) {
        //     for (let i = 0; i < this.job.parent_additional_notes.length; i++) {
        //         if (this.job.parent_additional_notes[i].is_note_alert) {
        //             this.alert_additional_notes[this.alert_additional_notes.length] = this.job.parent_additional_notes[i];
        //         }
        //         // add the parent note.
        //         this.parent_additional_notes[this.parent_additional_notes.length] = this.job.parent_additional_notes[i];
        //     }
        // }

        // check if notes are there to display
        if (this.alert_additional_notes.length > 0 || this.alert_manager_notes.length > 0) {
            this._modalRef = this.modalService.open(this.templateRef, { size: 'lg' });
        }
    }

    closeModal() {
        this._modalRef.close();
    }

    changeNoteAlertState(note_id, job_id) {
        // get status of note
        let status = jQuery('#' + this.idPrefix + 'note_' + note_id).prop('checked');
        this.is_loading = true;
        const request = this.isHome
            ? this.jobService.changeHomeNoteStatus({ 'status': status, 'note_id': note_id }, job_id)
            : this.jobService.changeAdditionalNoteStatus({ 'status': status, 'note_id': note_id }, job_id);
        request.subscribe(
            data => {
                this.is_loading = false;

                // only child job.
                if (this.job.job_id == job_id) {
                    this.additional_notes = data.data;
                }
            }
        );
    }

    timeConvert(date : any){
        var dateobj = new Date(date);
        return dateobj.toUTCString();
    }

    deleteNote(i, job){
        Swal({
            title: 'Warning',
            text: 'Do You Want To Delete?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        })
        .then((result) => {
            if (result.value) {
            const request = this.isHome
                ? this.jobService.deleteHomeNote({ id: job.job_home_note_id }, job.job_id)
                : this.jobService.deleteNote({id:job.job_note_id}, job.job_id);
            request.subscribe(
              data => {
                  
                    this.additional_notes = data.data;
                        Swal({
                            title: 'Success',
                            text: 'Deleted successfully'
                        })
              }, error => {
                  
              }
            );
        }
    })
    
  }

}
